<template>
  <div  :style="{backgroundColor: projectDescriptionData.descriptionBackgroundColor}" class="description-customer">
    <div class="customer-description-textdiv">
      <h1 class="customer-description-title" :style="{color: projectDescriptionData.descriptionTitleColor}">{{ projectDescriptionData.descriptionTitle}}</h1>
      <h2 class="customer-description-subtitle">{{ projectDescriptionData.descriptionSubTitle }}</h2>
      <p class="customer-description-text">{{ projectDescriptionData.descriptionText }}</p>
      <h1 class="customer-descriptionplatforms-text">{{ projectDescriptionData.platforms }}</h1>
    </div>
    <div class="customer-description-imagediv">
      <img :src="projectDescriptionData.descriptionImage" class="customer-description-image" v-if="projectDescriptionData.descriptionImage != ''">
    </div>
  </div>
</template>
<script>
  export default {
    name: 'CustomerDescription',
    props: {
      projectDescriptionData: {
        descriptionBackgroundColor: String,
        descriptionTitle: String,
        descriptionTitleColor: String,
        descriptionSubTitle: String,
        descriptionText: String,
        platforms: String,
        descriptionImage: String
      }
    }
  }

</script>
<style lang="scss" scoped>
  @import "../../assets/scss/customerDescription";
</style>



// WEBPACK FOOTER //
// src/pages/CustomersComponents/CustomerDescription.vue